import { CANVAS_ID } from "../../config/config";

export function getCanvasElement() {
    return document.getElementById(CANVAS_ID) as HTMLCanvasElement;
}
